const BODY_HEIGHT = 30;
const ARROW_HEIGHT = 8;
const TOTAL_HEIGHT = BODY_HEIGHT + ARROW_HEIGHT;
const ARROW_HALF_WIDTH = 8;
const RADIUS = BODY_HEIGHT / 2;
const MIN_WIDTH = 103;
const HORIZONTAL_PADDING = 26;
const LABEL_FONT = "700 15px 'Open Sans', sans-serif";

// Punto vertical donde Marker centra su label (mismo criterio que el
// Point(52,14) fijo que se usaba antes con el PNG de 103x38).
export const PRICE_ICON_LABEL_Y = Math.round(BODY_HEIGHT / 2) - 1;

let measureContext = null;
const getMeasureContext = () => {
  if (!measureContext) {
    measureContext = document.createElement('canvas').getContext('2d');
  }
  return measureContext;
};

// Ancho medido con el texto real (no por cantidad de caracteres): los
// precios varían mucho de ancho por carácter (comas, puntos, "US$"), a
// diferencia del contador de clusters que son solo dígitos.
export const getPriceIconSize = text => {
  const ctx = getMeasureContext();
  ctx.font = LABEL_FONT;
  const textWidth = ctx.measureText(String(text)).width;
  return {
    width: Math.max(MIN_WIDTH, Math.round(textWidth) + HORIZONTAL_PADDING),
    height: TOTAL_HEIGHT,
  };
};

const TEXT_COLOR = '#5E5E5E';
const BODY_FILL = '#FFFFFF';

const PIN_STYLES = {
  default: {
    fill: BODY_FILL,
    stroke: '#D8DCE3',
    strokeWidth: 1.5,
    text: TEXT_COLOR,
  },
  fav: { fill: BODY_FILL, stroke: '#F6D330', strokeWidth: 3, text: TEXT_COLOR },
};

// El hover usa el color de marca del sitio, que llega ya resuelto por prop:
// este módulo devuelve un string SVG, no es un componente y no puede leer el
// theme por su cuenta.
const getPinStyle = (isHovered, isFav, hoverColor) => {
  if (isHovered) {
    return {
      fill: BODY_FILL,
      stroke: hoverColor,
      strokeWidth: 1.5,
      text: hoverColor,
    };
  }
  return isFav ? PIN_STYLES.fav : PIN_STYLES.default;
};

export const getPriceLabelColor = (isHovered, isFav, hoverColor) =>
  getPinStyle(isHovered, isFav, hoverColor).text;

// Contorno continuo (cuerpo pill + flecha) en un solo path, en vez de
// superponer un rect y un triángulo. El `inset` mete el trazo hacia adentro
// para que el borde no se corte contra el límite del SVG.
const buildPinPath = (width, inset) => {
  const cx = width / 2;
  const arrowLeftX = cx - ARROW_HALF_WIDTH;
  const arrowRightX = cx + ARROW_HALF_WIDTH;
  const left = inset;
  const right = width - inset;
  const top = inset;
  const bodyBottom = BODY_HEIGHT - inset;
  const arrowTip = TOTAL_HEIGHT - inset;
  const radius = RADIUS - inset;

  return [
    `M ${left + radius},${top}`,
    `L ${right - radius},${top}`,
    `A ${radius},${radius} 0 0 1 ${right},${top + radius}`,
    `L ${right},${bodyBottom - radius}`,
    `A ${radius},${radius} 0 0 1 ${right - radius},${bodyBottom}`,
    `L ${arrowRightX},${bodyBottom}`,
    `L ${cx},${arrowTip}`,
    `L ${arrowLeftX},${bodyBottom}`,
    `L ${left + radius},${bodyBottom}`,
    `A ${radius},${radius} 0 0 1 ${left},${bodyBottom - radius}`,
    `L ${left},${top + radius}`,
    `A ${radius},${radius} 0 0 1 ${left + radius},${top}`,
    'Z',
  ].join(' ');
};

const MapPriceIcon = ({ width, isHovered, isFav, hoverColor }) => {
  const { fill, stroke, strokeWidth } = getPinStyle(
    isHovered,
    isFav,
    hoverColor
  );

  return `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${TOTAL_HEIGHT}">
      <path
        d="${buildPinPath(width, strokeWidth / 2)}"
        fill="${fill}"
        stroke="${stroke}"
        stroke-width="${strokeWidth}"
        stroke-linejoin="round"
      />
    </svg>
  `;
};

export default MapPriceIcon;
